'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import ProjectContactTableDirective from "./directive/projectContactTable";
import ProjectCuratorMizipTableDirective from "./directive/projectCuratorMizipTable";

export default angular.module('investmentProject.project.contact', [])
    .directive('projectContactTable', ProjectContactTableDirective)
    .directive('projectCuratorMizipTable', ProjectCuratorMizipTableDirective)
    .name;